export default function initializeVideoJs({
  videojs,
  baseUrl,
  retwitterBaseUrl,
  playlist,
  verifyUserUrl,
}) {
  window.videojs = videojs;

  window.player = videojs("js-video-player", {
    html5: {
      vhs: {
        // enable text track cues for stream metadata
        useCueTags: true,
      },
    },
    controls: true,
    techOrder: ["chromecast", "html5"],
    fluid: true,
    // aspectRatio: "16:9",
    //inactivityTimeout: 0, // For debug only
    controlBar: {
      volumePanel: {
        inline: true,
        volumeControl: {
          horisontal: true,
        },
      },
    },
    chromecast: {
      requestTitleFn: function (source) {
        return playlist[0].sources[0].title;
      },
      requestCustomDataFn: function (source) {
        return {
          id: playlist[0].sources[0].id,
          baseUrl,
          retwitterBaseUrl,
          verifyUserUrl,
          chromecastSrc: playlist[0].sources[0].chromecastSrc,
          licenseUrl:
            playlist?.[0]?.sources?.[0]?.keySystemOptions?.[0]?.options
              ?.serverURL,
          drmToken:
            playlist?.[0]?.sources?.[0]?.keySystemOptions?.[0]
              ?.chromecast_drm_token,
        };
      },
    },
    plugins: {},
  });

  // player.eme();

  player?.nuevo?.({
    shareMenu: false,
    zoomMenu: false,
    rateMenu: false,
    buttonRewind: false,
    playlistUI: true, // set to disable playlist UI completely
    playlistShow: false, // set to hide playlist UI on start
    playlistAutoHide: false, // Disable playlist UI autohide on video play event
    playlistNavigation: true, // set to show playlist navigation arrows
    playlistRepeat: false, // set to repeat playlist playback
  });

  videojs.addLanguage("en", {
    "The media could not be loaded, either because the server or network failed or because the format is not supported.": `The media could not be loaded, either because of the server or network error, 
      due to applied Geo-restrictions (not available for viewing in your country)  
      or because the format is not supported.`,
  });

  // on iPhone where fullscreen with HTML is not supported, fake it with a fixed position window, so that the EaseLive overlay can be displayed
  let supportsFullscreen = !!player.fsApi_.requestFullscreen;

  if (!supportsFullscreen) {
    player.getChild("controlBar").removeChild("FullscreenToggle");
    player.getChild("controlBar").addChild("FullWindowToggle");
  }

  return window.player;
}
